(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/api-calls/maps.js') >= 0) return;  svs.modules.push('/components/numbergames/api-calls/maps.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

(svs => {
  'use strict';

  svs.numbergames = svs.numbergames || {};
  svs.numbergames.utils = svs.numbergames.utils || {};
  svs.numbergames.utils.mapResultResponse = _ref => {
    let {
      result,
      product
    } = _ref;
    const resultData = result.result;
    const {
      productName,
      productId,
      drawNumber,
      regCloseTime
    } = _objectSpread({}, resultData);
    const returnObj = {
      productName,
      productId,
      drawNumber,
      regCloseTime
    };
    switch (product) {
      case 'keno':
        returnObj.numbers = resultData.numbers;
        returnObj.numbersExtra = resultData.kungKenoNumber;
        returnObj.distribution = resultData.distributionRegular;
        returnObj.distributionKungKeno = resultData.distributionKungKeno;
        returnObj.topWin = resultData.topWin;
        returnObj.totalPayout = resultData.totalPayout;
        returnObj.totalWinners = resultData.totalWinners;
        break;
      default:
        returnObj.numbers = resultData.drawResult[0].numbers;
        returnObj.numbersExtra = resultData.drawResult[1].numbers;
        returnObj.distribution = resultData.distribution;
        returnObj.winningCountry = resultData.winningCountry;
    }
    return returnObj;
  };
  if (typeof exports === 'object') {
    module.exports = svs.numbergames.utils;
  }
})(svs);

 })(window);